export const chatStatus = {
  Lead: 'Lead',
  Qualified: 'Qualified',
  Scheduled: 'Scheduled',
  NotQualified: 'Not Qualified',
};
